document.addEventListener('DOMContentLoaded', function() {
  const mainHeader = document.querySelector('.accordion-main-header');
  const wrapper = document.querySelector('.accordion-main-header-wrapper');
  const accordionSection = document.querySelector('.accordion-section');
  let ticking = false;
  let expandedBlocks = new Set();

  function updateMainHeaderPosition() {
    const wrapperRect = wrapper.getBoundingClientRect();
    const headerRect = mainHeader.getBoundingClientRect();
    const sectionRect = accordionSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the middle of the viewport
    const viewportCenter = windowHeight / 2;

    // Calculate the difference between the middle of the section and the viewport center
    const sectionMid = sectionRect.top + (sectionRect.height / 2);
    const distanceFromCenter = viewportCenter - sectionMid;

    // Calculate the available space the header can move within its wrapper
    const maxMovement = wrapperRect.height - headerRect.height;

    // Ensure the header's translation stays within the bounds of its wrapper
    let translateY = Math.min(Math.max(distanceFromCenter, 0), maxMovement);

    // Apply the translation to the header
    mainHeader.style.transform = `translateY(${translateY}px)`;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateMainHeaderPosition();
        updateBlocks();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateMainHeaderPosition);
  updateMainHeaderPosition(); // Initial position update

  function updateBlocks() {
    const windowHeight = window.innerHeight;
    const scrollPosition = window.scrollY;

    document.querySelectorAll('.accordion-header-image-block').forEach(block => {
      const blockRect = block.getBoundingClientRect();
      const blockTop = blockRect.top + scrollPosition;
      const blockBottom = blockRect.bottom + scrollPosition;

      if (blockTop < scrollPosition + windowHeight * 0.5) {
        expandBlock(block);
        expandedBlocks.add(block);
      } else if (blockBottom < scrollPosition) {
        // Keep the block expanded if we've scrolled past it
        if (expandedBlocks.has(block)) {
          expandBlock(block);
        } else {
          retractBlock(block);
        }
      } else {
        retractBlock(block);
        expandedBlocks.delete(block);
      }
    });
  }

  function expandBlock(block) {
    const description = block.querySelector('.accordion-header-image-description');
    const lineIndicator = block.querySelector('.line-indicator');
    block.classList.add('expanded');
    description.classList.add('visible');
    lineIndicator.style.backgroundColor = '#bf0000';
  }

  function retractBlock(block) {
    const description = block.querySelector('.accordion-header-image-description');
    const lineIndicator = block.querySelector('.line-indicator');
    block.classList.remove('expanded');
    description.classList.remove('visible');
    lineIndicator.style.backgroundColor = '#e0e0e0';
  }

  // Initial update
  updateBlocks();
});